import script from "./FormularioCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioCadastro.vue?vue&type=script&setup=true&lang=js"

import "./FormularioCadastro.vue?vue&type=style&index=0&id=43211f2b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43211f2b"]])

export default __exports__